// docs: https://github.com/altostra/type-validations#readme
import { is } from "@altostra/type-validations";
import { any } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsObjectsUsingCustomEventsResult = is(any);
